import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onChange"]
const _hoisted_2 = ["value"]
const _hoisted_3 = { for: "paiement_echeance_duration" }

import { ref, reactive, onMounted } from 'vue';
    import { generateUUID } from '@/utils';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MarketProduitFormAddVariantModal',
  props: {
        attributs: { type: Array as () => any[], required: true },
    },
  setup(__props, { expose: __expose }) {

    // @ts-expect-error raison: lib externe mal typée
    const props = __props;
    const isModalOpen = ref(false);
    let promise: Promise<any>;
    let resolvePromise: any;
    let rejectPromise: any;
    const formData = reactive({
        //attributs_valeurs: {} as any
        attributs: [] as any[],
    });
    const produit = reactive({
        id: null,
        nom: '',
    });

    onMounted(() => {
        /*props.attributs.forEach((attribut) => {
            formData.attributs_valeurs[attribut.nom] = null;
        });*/
    });

    async function open(_produit: any) {
        Object.assign(produit, _produit);
        promise = new Promise((resolve, reject) => {
            resolvePromise = resolve;
            rejectPromise = reject;
        });
        isModalOpen.value = true;
        return await promise;
    }

    function onClose() {
        resolvePromise(false);
    }

    function onConfirm() {
        const noms: any[] = [];
        const valeurs: any = {};
        Object.keys(formData.attributs).forEach((key: any) => {
            noms.push(formData.attributs[key].nom);
            valeurs[formData.attributs[key].nom] = formData.attributs[key].valeur;
        });
        resolvePromise(JSON.parse(JSON.stringify({
            guid: generateUUID(),
            nom: noms.join('|'),
            valeurs: valeurs,
            produit_attributs: formData.attributs
        })));
        isModalOpen.value = false;
    }

    function onReject() {
        resolvePromise(false);
        isModalOpen.value = false;
    }

    function onAttributValeurSelected(event: Event, attribut: any) {
        const target = event.target as HTMLSelectElement;
        const index = formData.attributs.findLastIndex((a: any) => a.nom === attribut.nom);
        if (index === -1) {
            formData.attributs.push({
                guid: generateUUID(),
                produit_id: produit.id,
                attribut_id: attribut.id,
                nom: attribut.nom,
                valeur: target.value,
            });
        } else {
            formData.attributs[index].valeur = target.value;
        }
    }

    __expose({ open });

return (_ctx: any,_cache: any) => {
  const _component_custom_modal = _resolveComponent("custom-modal")!

  return (_openBlock(), _createBlock(_component_custom_modal, {
    show: isModalOpen.value,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((isModalOpen).value = $event)),
    onClosed: onClose
  }, {
    header: _withCtx(() => [...(_cache[1] || (_cache[1] = [
      _createElementVNode("h4", { class: "font-semibold" }, "Formulaire Variant", -1)
    ]))]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        id: "btn-confirmation-confirm",
        class: "btn-ultra white2",
        style: {"justify-content":"center"},
        onClick: onConfirm
      }, "Valider"),
      _createElementVNode("button", {
        id: "btn-confirmation-reject",
        class: "btn-ultra white2",
        style: {"justify-content":"center"},
        onClick: onReject
      }, "Annuler")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.attributs, (attribut, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "form-field-floating full my-5",
            key: 'attribut_' + index
          }, [
            _createElementVNode("select", {
              class: "form-input-select",
              onChange: ($event: any) => (onAttributValeurSelected($event, attribut))
            }, [
              _cache[2] || (_cache[2] = _createElementVNode("option", { value: null }, "Aucun attribut sélectionné", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attribut.valeurs, (valeur) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: valeur,
                  value: valeur
                }, _toDisplayString(valeur), 9, _hoisted_2))
              }), 128))
            ], 40, _hoisted_1),
            _createElementVNode("label", _hoisted_3, _toDisplayString(attribut.nom), 1)
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})